import { Typography, ButtonBase } from '@material-ui/core'
import React from 'react'
import { useLocation } from 'react-router-dom'

import { LocalizedLink } from '../../routes/localizedRoutes'
import { RoomTypeBrief } from '../../types/roomtype'
import useStyles from './styles/RoomtypesTable.styles'

interface RoomtypeRowMobileProps {
  data: RoomTypeBrief
  hasAccessToViewRoomTypeTabs: boolean | undefined
}

const RoomtypeRowMobile: React.FC<RoomtypeRowMobileProps> = ({
  data,
  hasAccessToViewRoomTypeTabs
}) => {
  const { roomTypeCode, displayRoomTypeCode, name, id } = data
  const classes = useStyles()
  const location = useLocation()

  return (
    <>
      <ButtonBase
        className={classes.tableRowMobile}
        component={LocalizedLink}
        to={
          hasAccessToViewRoomTypeTabs
            ? `${location.pathname
                .replace('/list', '')
                .replace('/en', '')
                .replace('/fa', '')}/${id}/${roomTypeCode}/details`
            : ''
        }>
        <div className={classes.nameCell}>
          <div>
            <Typography variant="h4">{name}</Typography>
          </div>
        </div>
        <div>
          <Typography variant="body1">{displayRoomTypeCode}</Typography>
        </div>
      </ButtonBase>
    </>
  )
}

export default RoomtypeRowMobile
